import React from 'react';
import swal from 'sweetalert';
import moment from 'moment';
import { Link } from 'react-router-dom';

import { MOMENT_SPANISH_LANG } from '../../../config/defaults';

import View from './View';

import Server from '../../../services/Server';

moment.locale('es', MOMENT_SPANISH_LANG);

const Settings = (props) => {
	let { event = {}, helpers = {} } = props,
		{ encoder_rtmp = false } = helpers,
		{ countdown = true, organized = '' } = event,
		{
			live_stream = {},
			startDate,
			endDate,
			url = '',
			videoServer = '1566626989_2ZWqtfdRrxCA',
			id,
			webrtc = { id: false },
			webrtc_users = [],
		} = event,
		{
			source_connection_information = {},
			encoder = 'other_rtmp',
		} = live_stream,
		{
			primary_server = '',
			host_port = '',
			stream_name = '',
			username = '',
			password = '',
		} = source_connection_information;

	const [encoderMethod, setEncoderMethod] = React.useState(encoder),
		[isEncoderLoading, setEncoderLoading] = React.useState(false),
		[needLiveStream, setNeedLiveStream] = React.useState(
			event.live_stream === undefined
		),
		[needLiveStreamError, setNeedLiveStreamError] = React.useState(false),
		[countDownStatus, setCountDownStatus] = React.useState(countdown),
		[loadingDownStatus, setLoadingCountDownStatus] = React.useState(false),
		[status, setStatus] = React.useState('loading');

	const handleCountDownStatus = () => {
		setLoadingCountDownStatus(true);
		props.firebase
			.updateById('events', event.id, { countdown: !countDownStatus })
			.then(() => {
				setCountDownStatus(!countDownStatus);
				setLoadingCountDownStatus(false);
			})
			.catch(() => {
				setLoadingCountDownStatus(false);
			});
	};

	React.useEffect(() => {
		if (needLiveStream) {
			Server.events
				.create(videoServer, event.id, event.url)
				.then((live_stream_data) => {
					if (live_stream_data.data.status === 200) {
						props.onUpdateDoc(
							{ live_stream: live_stream_data.data.live_stream },
							() => {
								props.getEventData();
								setNeedLiveStream(false);
							}
						);
					}
				})
				.catch(() => {
					setNeedLiveStreamError(true);
				});
		}
	}, [event.id, event.url, needLiveStream, props, videoServer]);

	if (needLiveStream) {
		if (needLiveStreamError) {
			return (
				<div className="alert alert-danger mg-t-30 tx-center">
					<span>
						En este momento no es posible cargar esta sección, por favor vuelve
						en unos momentos
					</span>
				</div>
			);
		}
		return (
			<div className="cnt-no-setup-event">
				<i className="fas fa-spinner fa-spin" style={{ color: '#33077c' }}></i>
			</div>
		);
	}

	const _timeMargin = { value: 60, label: 'MINUTES' },
		_startDate = startDate.format('YYYY-MM-DD HH:mm:ss'),
		_endDate = endDate.format('YYYY-MM-DD HH:mm:ss'),
		_startTimeMargin = moment(_startDate).add(
			_timeMargin.value * -1,
			_timeMargin.label
		),
		_endTimeMargin = moment(_endDate).add(_timeMargin.value, _timeMargin.label),
		_now = moment(),
		eventStatus = event.getStatus().code;

	let isBlocked = true,
		_blockedMessage = '';

	if (eventStatus > 0) {
		if (_startTimeMargin.isBefore(_now) && _now.isBefore(_endTimeMargin)) {
			isBlocked = false;
		} else {
			if (_startTimeMargin.isBefore(_now)) {
				_blockedMessage = `El evento finalizó en ${_endTimeMargin.format(
					'MMMM DD hh:mm a'
				)}`;
			} else {
				_blockedMessage = `El evento empezará en ${_startTimeMargin.format(
					'MMMM DD hh:mm a'
				)}`;
			}
		}
	} else {
		_blockedMessage = (
			<React.Fragment>
				<span>El evento aún no ha sido configurado</span>,{' '}
				<Link to="./edit">puedes configurarlo aqui</Link>
			</React.Fragment>
		);
	}

	const changeBroadcastMethod = (newMethod) => {
		if (newMethod !== encoderMethod) {
			if (live_stream.id) {
				if (live_stream.name) {
					setEncoderMethod('none');
					setEncoderLoading(true);
					Server.events
						.setEncoder(
							videoServer,
							live_stream.id,
							live_stream.name,
							webrtc.id,
							newMethod
						)
						.then((response) => {
							setEncoderMethod(newMethod);
							setEncoderLoading(false);
						})
						.catch(() => {
							swal(
								'Hubo un error',
								'En este momento no es posible hacer el cambio',
								'error'
							);
							setEncoderLoading(false);
						});
				}
			}
		}
	};

	const updatePlayer = () => {
		return Server.events.updatePlayer(id);
	};

	let statusClass;
	switch (status) {
		case 'started':
			statusClass = 'success';
			break;
		case 'starting':
			statusClass = 'warning';
			break;
		case 'loading':
			statusClass = 'warning';
			break;
		case 'resetting':
			statusClass = 'warning';
			break;
		default:
			statusClass = 'danger';
			break;
	}

	return (
		<View
			url={url}
			statusClass={statusClass}
			status={status}
			loadingDownStatus={loadingDownStatus}
			countDownStatus={countDownStatus}
			handleCountDownStatus={handleCountDownStatus}
			isBlocked={isBlocked}
			setStatus={setStatus}
			startDate={startDate}
			videoServer={videoServer}
			id={id}
			live_stream={live_stream}
			_blockedMessage={_blockedMessage}
			primary_server={primary_server}
			host_port={host_port}
			stream_name={stream_name}
			username={username}
			password={password}
			encoderMethod={encoderMethod}
			changeBroadcastMethod={changeBroadcastMethod}
			organized={organized}
			isEncoderLoading={isEncoderLoading}
			encoder_rtmp={encoder_rtmp}
			firebase={props.firebase}
			webrtc_users={webrtc_users}
			updatePlayer={updatePlayer}
		/>
	);
};

export default Settings;
